import type { SVGComponentProps } from 'BreetHelpers';

export const FullStopIcon = ({ ...props }: SVGComponentProps) => (
	<svg
		width='4'
		height='5'
		viewBox='0 0 4 5'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<rect
			y='0.191406'
			width='4'
			height='4'
			rx='2'
			fill='var(--neutral-light)'
		/>
	</svg>
);
